import React from 'react';
import PropTypes from 'prop-types';

import Settings from './settings';
import Clear from './clear';

import LaunchDarkly from '@module/launchdarkly';

import { FF_COOKIE_WALL } from '@app/constant/experiments';

const CookieManager = ({
  loggedIn,
  isProUser,
  allowTracking,
  notified,
  updateFormState,
}) => (
  <div className="cookie-manager">
    {LaunchDarkly.getVariant(FF_COOKIE_WALL) && !isProUser && (
      <Settings
        savedTrackingSettings={allowTracking}
        notified={notified}
        updateFormState={updateFormState}
      />
    )}
    <Clear loggedIn={loggedIn} />
  </div>
);

CookieManager.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  isProUser: PropTypes.bool.isRequired,
  allowTracking: PropTypes.bool.isRequired,
  notified: PropTypes.bool.isRequired,
  updateFormState: PropTypes.func.isRequired,
};

export default CookieManager;
